/* AJK SOUQ – premium helpers (v3: fast entrances + off-screen animation pause for smooth mobile scrolling) */

/* 1) legacy scroll-reveal (kept for trust badges, comparison table, landing blocks) */
(function(){
  if(!('IntersectionObserver' in window)) return;
  var sel=['[class^="ai-trust-badge-item-"]','[class^="ai-comparison-table__table-"]','[class^="ai-product-landing-content-"]','[class^="ai-product-landing-image-wrapper-"]','.alm-reveal'];
  function init(){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('alm-in');io.unobserve(e.target);}});},{threshold:.05,rootMargin:'0px 0px 12% 0px'});
    document.querySelectorAll(sel.join(',')).forEach(function(el,i){
      if(el.classList.contains('alm-pre')||el.classList.contains('alm-in')) return;
      var r=el.getBoundingClientRect();
      if(r.top<window.innerHeight&&r.bottom>0&&!el.classList.contains('alm-reveal')) return; /* already visible: don't hide */
      el.classList.add('alm-pre'); io.observe(el);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();

/* 2) one-time entrance observer – starts BEFORE the element is on screen so nothing "waits" */
(function(){
  var SEL='[data-ajk-enter],[data-ajk-stagger],[data-ajk-float]';
  function show(el){el.classList.add('is-in');}
  function init(){
    var els=[].slice.call(document.querySelectorAll(SEL));
    els.forEach(function(el){
      if(el.__ajkInit)return; el.__ajkInit=1;
      if(el.hasAttribute('data-ajk-stagger')){[].forEach.call(el.children,function(c,i){c.style.setProperty('--ajk-i',i);});}
    });
    if(!('IntersectionObserver' in window)||(window.Shopify&&window.Shopify.designMode)){els.forEach(show);return;}
    function mk(opt){return new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){show(e.target);this.unobserve(e.target);}},this);
    },opt);}
    var io=mk({threshold:0,rootMargin:'0px 0px 18% 0px'});
    var iof=mk({threshold:0,rootMargin:'0px 0px 35% 0px'});
    els.forEach(function(el){if(el.classList.contains('is-in'))return;(el.hasAttribute('data-ajk-float')?iof:io).observe(el);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:block:select',init);
})();

/* 3) pause every infinite CSS animation that is not on screen (big win for mobile scroll smoothness) */
(function(){
  if(!('IntersectionObserver' in window)) return;
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){e.target.classList.toggle('ajk-offscreen',!e.isIntersecting);});
  },{rootMargin:'120px 0px 120px 0px'});
  function init(){
    document.querySelectorAll('.shopify-block,.shopify-section').forEach(function(el){
      if(el.__ajkVis) return; el.__ajkVis=1; io.observe(el);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:block:select',init);
})();
